import React from 'react';

const IconFiverr = () => (
  <svg width="800px" height="800px" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <style>
        .a&fbrace;fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;&rbrace;
      </style>
    </defs>
    <path
      className="a"
      d="M30.7087,4.5H23.2355c-5.4473,0-10.1982,4.2944-9.88,12.0757H7.9886v7.2454h5.7247V43.5H22.211V23.8211h8.8555V43.5h8.9449V16.5758H22.7478V14.6973a2.8052,2.8052,0,0,1,2.8484-2.9518h5.1125Z"
    />
  </svg>
);

export default IconFiverr;
